import React, { useEffect, useState } from 'react';
import YouTube from 'react-youtube';
import useAuth from '~/hooks/useAuth';

import proBridge from '~/utils/pro-bridge';
import apiCall, { LIVE_URL } from '~/utils/apiCall';
import BG from '~/components/background';

import top from './images/top.png';
import content from './images/content.png';
import bottom from './images/bottom.png';
import event from './images/event.png';
import agree01 from './images/agree1.png';
import agree02 from './images/agree2.png';

import q1 from './images/01.png';
import q2 from './images/02.png';
import q3 from './images/03.png';
import q4 from './images/04.png';
import q5 from './images/05.png';

import q1C from './images/01_checked.png';
import q2C from './images/02_checked.png';
import q3C from './images/03_checked.png';
import q4C from './images/04_checked.png';
import q5C from './images/05_checked.png';

import day01 from './images/day01.png';
import day02 from './images/day02.png';
import day03 from './images/day03.png';
import day04 from './images/day04.png';
import day05 from './images/day05.png';

import buttonImg from './images/button.png';

import { 
  Top, Content, ButtonWrap, AgreeWrap, LabelWrap, Label, 
  Checkbox, Ul, Overlay, ArrowWrap
} from './styled'; 

function Arrow() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path fill="#E5EBFD" d="M0 0H40V40H0z" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000)"/>
        <path stroke="#A1ABC2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M27 9L27 23 13 23" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000) translate(20.000000, 16.000000) rotate(-315.000000) translate(-20.000000, -16.000000)"/>
      </g>
    </svg>
  );
}

function ProEventComponent() {
  const { authKey } = useAuth();
  const [isOpen, setOpen] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [pop1, setPop1] = useState(false);
  const [pop2, setPop2] = useState(false);
  const [state, setState] = useState({
    isApplyFirst: false,
    isApplySecond: false,
    isApplyThird: false,
    isApplyFourth: false,
    isApplyFifth: false,
  });
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    getEventInfo();
  }, [authKey]);

  async function getEventInfo() {
    try {
      const { result, code, msg } = await apiCall.get(`${LIVE_URL}/api/v1/pro/event/20210901`, { authKey });
      const errorCode = [502, 503, 504, 505, 506];
      if (errorCode.includes(code)) return alert(msg);
      setState(result);
    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  async function onClickButton() {
    if (!agree1) return alert('개인정보 수집/이용 에 대한 동의를 체크 해주세요.');
    if (!agree2) return alert('개인정보 제공(위탁)에 대한 동의를 체크 해주세요.');

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/pro/event/20210901`, { authKey });
      const errorCode = [502, 503, 504, 505, 506];

      if (res?.code === 501) {
        alert(res?.msg);
        proBridge.ios(call => {
          call.callHandler('iOS Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        proBridge.android(call => {
          console.log('android');
          call.showLoginAndReload();
        });

        return;
      }

      if (errorCode.includes(res?.code)) return alert(res?.msg);

      const { isApplyFirst, isApplySecond, isApplyThird, isApplyFourth, isApplyFifth } = res.result;
      const src = isApplyFifth ? day05 : isApplyFourth ? day04 : isApplyThird ? day03 : isApplySecond ? day02 : isApplyFirst ? day01 : null;
      
      if (src !== null) {
        setImgSrc(src);
        setOpen(true);
      }
      setState(res.result);
    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return (
    <>
      <div>
        <Top>
          <div className="youtube-wrap">
            <YouTube videoId="c6B5ANozUDE" />
          </div>
          <BG width={710} height={1074} imgUrl={top} />
        </Top>

      <Content>
        <BG width={710} height={765} imgUrl={content} />
        <div className="q1">
          <img className="q1" src={state.isApplyFirst ? q1C : q1} alt="" />
          <img className="q2" src={state.isApplySecond ? q2C : q2} alt="" />
          <img className="q3" src={state.isApplyThird ? q3C : q3} alt="" />
          <img className="q4" src={state.isApplyFourth ? q4C : q4} alt="" />
          <img className="q5" src={state.isApplyFifth  ? q5C : q5} alt="" />
        </div>
        <ButtonWrap onClick={onClickButton}>
          <BG width={288} height={71} imgUrl={buttonImg} />
        </ButtonWrap>
      </Content>
      <AgreeWrap>
        <LabelWrap isCheck={pop1}> 
          <Label>
            <Checkbox type="checkbox" checked={agree1} onChange={() => {setAgree1(prev => !prev); setPop1(true);}} />
            <p>개인정보 수집/이용 에 대한 동의</p>
          </Label>
          <ArrowWrap onClick={() => setPop1(prev => !prev)}>
            <Arrow/>
          </ArrowWrap>
        </LabelWrap>
  
        {pop1 && (
          <BG width={608} height={140} imgUrl={agree01} />
        )}
  
        <LabelWrap isCheck={pop2}>
          <Label>
            <Checkbox type="checkbox" checked={agree2} onChange={() => {setAgree2(prev => !prev); setPop2(true);}} />
            <p>개인정보 제공(위탁)에 대한 동의</p>
          </Label>
          <ArrowWrap onClick={() => setPop2(prev => !prev)}>
            <Arrow/>
          </ArrowWrap>
        </LabelWrap>
  
        {pop2 && (
          <BG width={616} height={170} imgUrl={agree02} />
        )}
      </AgreeWrap>
        <div>
          <BG width={710} height={898} imgUrl={event} />
        </div>

        <div>
          <BG width={710} height={619} imgUrl={bottom} />
        </div>
      </div>
      {isOpen && (
        <Overlay>
          <img src={imgSrc} alt="" onClick={() => setOpen(false)} />
        </Overlay>
      )}
    </>
  );
}

export default ProEventComponent;